<template>
  <div>
    <GkLogo :full="false" id="butler-tt" :fill="theme" />
    <b-popover
      :target="'butler-tt'" 
      :placement="popoverPlacement"
      :fallback-placement="[popoverPlacement]"
      :triggers="(isTyping || finalLine) ? 'manual' : 'hover'"
      :custom-class="'popover-light popover-butler ' + ((placed) ? 'placed' : '')" 
    >
      <div @click="checkFinal" class="popover-text" ref="butler-popover-text" v-html="renderedMessage" />
    </b-popover>
  </div>
</template>

<script>
import GkLogo from '@/components/ui/GkLogo.vue'
export default {
  name: 'GkButler',
  components: {
    GkLogo
  },
  props: {
    nextLine: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: 'brand'
    },
    silent: {
      type: Boolean,
      default: false
    },
    placed: {
      type: Boolean,
      default: false
    },
    finalLine: {
      type: Boolean,
      default: false
    },
    mobileView: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      splitWords: [],
      typingSpeed: 10,
      typeTimeout: null,
      hideTimeout: null,
      letterIndex: 0,
      wordIndex: 0,
      ttKey: 0,
      messageHeight: '0px',
      renderedMessage: null,
      isTyping: false
    };
  },
  computed: {
    messageShowTime () {
      const wordsPerSecond = 7
      const minTimeout = 1000
      const maxTimeout = 5000
      const timeout = Math.max(
        minTimeout, 
        Math.min((this.splitWords.length / wordsPerSecond) * 1000, maxTimeout)
      )
      return timeout
    },
    popoverPlacement () {
      let placement = ''
      if (this.placed) {
        placement = 'right'
      } else {
        if (this.mobileView) {
          placement = 'topright'
        } else {
          placement = 'righttop'
        }
      }
      return placement
    }
  },
  watch: {
    nextLine (newValue) {
      if (newValue && newValue !== '') {
        if (this.finalLine) {
          // wait for butler to finish moving
          this.$root.$emit('bv::hide::popover', 'butler-tt')
          setTimeout(() => {
            this.startTyping()
          }, 500)
        } else {
          this.startTyping()
        }
      }
    }
  },
  created () {
    // this.setMessageHeight()
  },
  beforeDestroy () {
    clearTimeout(this.typeTimeout)
    clearTimeout(this.hideTimeout)
  },
  mounted () {
    if (this.nextLine) {
      this.startTyping()
    }
  },
  methods: {
    setMessageHeight () {
      // this.messageHeight = this.calculateMessageBoxHeight(this.nextLine)
      // document.documentElement.style.setProperty('--wiz-butler-msg-height', this.messageHeight);
    },
    startTyping () {
      this.isTyping = true
      setTimeout(() => {
        // timeout to ensures popover component is mounted before trying to ::show()
        clearTimeout(this.typeTimeout)
        clearTimeout(this.hideTimeout)
        this.emptyMessageBox()
        // this.setMessageHeight()
        this.$root.$emit('bv::show::popover', 'butler-tt')
        this.letterIndex = 0
        this.wordIndex = 0
        this.splitWords = this.nextLine.split(' ')
        setTimeout(() => {
          // timeout to give popover time to render after ::show()
          this.typeText()
        }, 100)
      }, 300)
    },
    typeText() {
      if (this.silent) return
      if (this.wordIndex < this.splitWords.length) {
        if (this.letterIndex === 0) {
          // add a new word-span and update counters
          this.addWordSpan()
        }
        if (this.letterIndex < this.splitWords[this.wordIndex].length) {
          this.addMessageLetter(this.splitWords[this.wordIndex][this.letterIndex])
          this.letterIndex++
          if (this.letterIndex >= this.splitWords[this.wordIndex].length) {
            this.wordIndex++
            this.letterIndex = 0
          } 
          this.typeTimeout = setTimeout(this.typeText, this.typingSpeed)
        }
      } else {
        console.log('finished typing')

        if (this.finalLine) {
          this.addFinalButton()
        }

        /**
         * After typing is complete wait x time before hidding the popover
         * and emit event (to place butler when splash screen)
         */
        this.hideTimeout = setTimeout(() => {
          const popover_text = this.$refs['butler-popover-text']
          if (popover_text && !this.finalLine) {
            this.renderedMessage = popover_text.innerHTML
          }
          this.isTyping = false
          if (!this.finalLine) {
            this.$root.$emit('bv::hide::popover', 'butler-tt')
          }
          if (!this.placed) {
            this.$emit('finished-typing', false)
          }
        }, this.messageShowTime);
      }
    },
    addWordSpan () {
      const popover_text = this.$refs['butler-popover-text']
      const span = document.createElement('span')
      span.id = 'word-span-' + this.wordIndex
      span.classList.add('butler-msg-word')
      if (popover_text) {
        popover_text.appendChild(span)
      }
    },
    addMessageLetter (letter) {
      const popover_word = document.getElementById('word-span-' + this.wordIndex)
      const span = document.createElement('span')
      span.textContent = letter
      if (letter === ' ') {
        span.classList.add('letterspace')
      }
      span.classList.add('butler-msg-letter')
      if (popover_word) {
        popover_word.appendChild(span)
      }
      this.ttKey++ // to reposition popover properly
    },
    checkFinal () {
      if (this.finalLine) {
        this.$emit('lets-begin', false)
      }
    },
    addFinalButton () {
      const popover_text = this.$refs['butler-popover-text']
      const button_div = document.createElement('div')
      button_div.classList.add('butler-msg-button')
      button_div.innerHTML = '<button id="lets-begin-btn" class="btn btn-brand">' + this.$gettext('Let\'s Begin!') + '</button>'
      if (popover_text) {
        popover_text.appendChild(button_div)
      }

      const letsBeginButton = document.getElementById('lets-begin-btn')
      if (letsBeginButton) {
        letsBeginButton.addEventListener('click', () => {
          this.$emit('lets-begin', false)
        })
      }
    },
    emptyMessageBox () {
      // empty message div
      this.renderedMessage = null
      const popover_text = this.$refs['butler-popover-text']
      if (popover_text) {
        popover_text.innerHTML = ''
      }
    },
    // calculateMessageBoxHeight (text) {
    //   const font_size = (this.mobileView) ? 16 : 18
    //   const line_height = (this.mobileView) ? 1.3 : 1.5
    //   const box_width = (this.mobileView) ? 220 : 350
    //   const box_padding = (this.mobileView) ? 8 : 16
    //   const tempDiv = document.createElement('div')
    //   tempDiv.id = 'test-div'
    //   tempDiv.style.width = box_width + 'px'
    //   tempDiv.style.padding = box_padding + 'px'
    //   tempDiv.style.fontSize = `${font_size}px`
    //   tempDiv.style.lineHeight = line_height
    //   tempDiv.style.visibility = 'hidden'
    //   tempDiv.style.position = 'absolute'
    //   tempDiv.style.whiteSpace = 'normal'
    //   tempDiv.textContent = text
    //   tempDiv.style.border = '2px solid black'

    //   document.body.appendChild(tempDiv)
    //   let box_height = tempDiv.offsetHeight
    //   document.body.removeChild(tempDiv)

    //   if (this.finalLine) box_height += 50
    //   return box_height + 'px'
    // }
  }
};
</script>

<style lang="scss">
#lets-begin-btn {
  margin-top: 1rem;
}
.butler-msg-word {
  display: inline-block;
  margin-left: 5px;
  .butler-msg-letter {
    display: inline-block;
    animation: letterappear 0.5s cubic-bezier(0.000, 0.125, 0.000, 1.650) 1;
    &.letterspace {
      width: 5px;
    }
  }
}

@keyframes letterappear {
  0% {
    opacity: 0;
    transform: translateX(10px) scale(0.7) rotate(30deg);
  }
  100% {
    opacity: 1;
    transform: rotate(0deg);
  }
}

.popover.b-popover {
  &.popover-butler {
    $popoverPadding: 1rem;
    $popoverBorder: 2px;
    padding: 0 $popoverPadding;
    // width: 270px;
    max-width: 65%;
    min-height: 63px;
    // height: var(--wiz-butler-msg-height);
    transition: opacity 0.2s ease, height 0.2s ease;
    border: $popoverBorder solid #e5e5e5;
    border-radius: $radiusLg;
    padding: 0rem;

    &.bs-popover-right { margin-left: 1rem; }
    &.bs-popover-top { 
      .arrow { 
        transform: translate(16px, 16px) rotate(90deg) scaleX(-1);
      }
    }

    .arrow { 
      width: 20px;
      height: 31px;
      left: -20px;
      margin: 0;
      padding: 0;
      z-index: 200;
      background-image: url('/static/img/butler-arrow.svg');
      background-repeat: no-repeat;
      transform: translateY(-10px);

      &:before, &:after {
        display: none;
      }
    }
    .popover-body {
      width: 100%;
      height: 100%;
      padding: 0.5rem;
      .popover-text {
        font-size: 16px;
        line-height: 1.3;
        color: $colorTextBase;
        font-family: DINNextLTPro-Regular, sans-serif;
      }
    }
    @media (min-width: 576px) {
      max-width: 350px;
      // width: 300px;
      .popover-body {
        padding: 1rem;
        .popover-text {
          font-size: 18px;
          line-height: 1.5;
        }
      }
    }
    &.placed {
      .popover-body {
        .popover-arrow {
          transform: translate(-100%, -85%);
        }
      }
    }
  }
}
</style>